import { render, staticRenderFns } from "./collectionParam.vue?vue&type=template&id=11a22455&scoped=true&"
import script from "./collectionParam.vue?vue&type=script&lang=js&"
export * from "./collectionParam.vue?vue&type=script&lang=js&"
import style0 from "./collectionParam.vue?vue&type=style&index=0&id=11a22455&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a22455",
  null
  
)

export default component.exports